export default function PrivacyPolicy() {
  return (
    <div className="page-content about-page">
      <h2>Privacy Policy</h2>

      <section className="about-section">
        <h3>Overview</h3>
        <p>
          DHTools is a free reference tool. Your privacy matters. This page explains what limited data is collected and why.
        </p>
      </section>

      <section className="about-section">
        <h3>Traffic Analytics</h3>
        <p>
          DHTools uses GoatCounter to collect basic anonymous traffic data (page views, referrer, browser, and general location by country). This is the only analytics tool used on this site.
        </p>
        <p>
          GoatCounter does not use cookies, does not track individuals across sites, and does not collect personally identifiable information. Data is aggregated and anonymous.
        </p>
        <a href="https://www.goatcounter.com" className="about-link" target="_blank" rel="noopener noreferrer">goatcounter.com</a>
      </section>

      <section className="about-section">
        <h3>Bug Reports & Feedback</h3>
        <p>
          When you submit a bug report or feedback, your email address and message are collected through Formspree solely to allow a response to your submission.
        </p>
        <p>
          Your email will never be sold, shared with third parties, used for marketing, or stored beyond what is needed to respond to your message.
        </p>
      </section>

      <section className="about-section">
        <h3>Cookies & Local Storage</h3>
        <p>
          DHTools stores your theme and font size preferences, and the characters you build (up to 5), locally in your browser using localStorage. This data never leaves your device and is not transmitted anywhere. Clearing your browser's cookies and site data deletes it, characters included.
        </p>
      </section>

      <section className="about-section">
        <h3>Contact</h3>
        <p>Questions about this policy:</p>
        <a href="mailto:waleedalnaimi117@gmail.com" className="about-link">
          waleedalnaimi117@gmail.com
        </a>
      </section>

      <section className="about-section">
        <p style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
          Last updated: October 2026
        </p>
      </section>
    </div>
  );
}
